"use strict";

var marko_template = module.exports = require("marko/dist/vdom").t(),
    components_registry_browser = require("marko/dist/runtime/components/registry-browser"),
    marko_registerComponent = components_registry_browser.r,
    marko_componentType = marko_registerComponent("/MP.WEB$2.0/src/views/smoothy~1.0/pages/Classroom/Learner/components/Course/components/CourseInformation.marko", function() {
      return module.exports;
    }),
    marko_renderer = require("marko/dist/runtime/components/renderer"),
    marko_defineComponent = require("marko/dist/runtime/components/defineComponent"),
    Locale_template = require("../../../../../../../components/Locale/index.marko"),
    marko_loadTag = require("marko/dist/runtime/helpers/load-tag"),
    Locale_tag = marko_loadTag(Locale_template),
    Schedules_template = require("../../../../../../components/Schedules.marko"),
    Schedules_tag = marko_loadTag(Schedules_template),
    Preloader_template = require("../../../../../../../components/Preloader/index.marko"),
    Preloader_tag = marko_loadTag(Preloader_template),
    QuillEditor_template = require("../../../../../../../components/QuillEditor/index.marko"),
    QuillEditor_tag = marko_loadTag(QuillEditor_template),
    Price_template = require("../../../../../../../components/Price/index.marko"),
    Price_tag = marko_loadTag(Price_template),
    Row_template = require("../../../../../../../components/Row/index.marko"),
    Row_tag = marko_loadTag(Row_template),
    marko_forOf = require("marko/dist/runtime/helpers/for-of"),
    DifficultyLevel_template = require("../../../../../../components/DifficultyLevel.marko"),
    DifficultyLevel_tag = marko_loadTag(DifficultyLevel_template),
    Card_template = require("../../../../../../components/Card.marko"),
    Card_tag = marko_loadTag(Card_template),
    AutoScroll_template = require("marko-perfect-scrollbar/index.marko"),
    AutoScroll_tag = marko_loadTag(AutoScroll_template),
    marko_attrs0 = {
        "class": "p-3"
      },
    marko_attrs1 = {
        "class": "text-muted text-uppercase"
      },
    marko_attrs2 = {
        "class": "card-title"
      },
    marko_attrs3 = {
        "class": "blue-grey-text"
      },
    marko_createElement = require("marko/dist/runtime/vdom/helpers/v-element"),
    marko_const = require("marko/dist/runtime/vdom/helpers/const"),
    marko_const_nextId = marko_const("2fdb6c"),
    marko_node0 = marko_createElement("br", null, "14", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_node1 = marko_createElement("br", null, "15", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_attrs4 = {
        "class": "btn btn-outline-light float-right"
      },
    marko_attrs5 = {
        "class": "card-text mt-2 pr-6"
      },
    marko_node2 = marko_createElement("br", null, "10", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_attrs6 = {
        "class": "btn btn-primary btn-lg"
      },
    marko_attrs7 = {
        "class": "card"
      },
    marko_attrs8 = {
        "class": "card-content"
      },
    marko_attrs9 = {
        "class": "list-group"
      },
    marko_attrs10 = {
        "class": "list-group-item only-dark-bg-fade border-bottom"
      },
    marko_attrs11 = {
        "class": "list-group-item only-dark-bg-fade border-bottom"
      },
    marko_attrs12 = {
        "class": "list-group-item only-dark-bg-fade border-bottom"
      },
    marko_node3 = marko_createElement("br", null, "81", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_attrs13 = {
        "class": "list-group-item only-dark-bg-fade border-bottom"
      },
    marko_node4 = marko_createElement("i", {
        "class": "bx bx-purchase-tag-alt mr-4"
      }, "37", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_attrs14 = {
        "class": "list-group-item only-dark-bg-fade border-bottom"
      },
    marko_node5 = marko_createElement("i", {
        "class": "bx bx-package mr-4"
      }, "44", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_attrs15 = {
        "class": "list-inline m-0"
      },
    marko_attrs16 = {
        "class": "px-25"
      },
    marko_attrs17 = {
        "class": "chip theme-bg-lighten"
      },
    marko_attrs18 = {
        "class": "chip-body font-small-5"
      },
    marko_attrs19 = {
        "class": "chip-text py-25"
      },
    marko_node6 = marko_createElement("i", {
        "class": "bx bx-label mr-4"
      }, "54", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_node7 = marko_createElement("i", {
        "class": "bx bx-star mr-4"
      }, "61", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_node8 = marko_createElement("i", {
        "class": "bx bx-world mr-4"
      }, "68", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_attrs20 = {
        "class": "m-0"
      },
    marko_node9 = marko_createElement("br", null, "76", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_attrs21 = {
        "class": "mb-2"
      },
    marko_attrs22 = {
        "class": "btn btn-primary btn-block btn-lg"
      };

function render(input, out, __component, component, state) {
  var data = input;

  AutoScroll_tag({
      height: "100vh",
      class: "classroom-info position-absolute zindex-3 top-0 w-100 theme-bg animated slideInUp faster",
      renderBody: function(out) {
        out.be("div", marko_attrs0, "1", component);

        if (input.status !== "new") {
          out.be("button", marko_attrs4, "2", component, null, 0, {
              onclick: __component.d("click", () => component.emit('dismiss'), false)
            });

          Locale_tag({
              text: "Dismiss"
            }, out, __component, "3");

          out.ee();
        }

        out.be("div", marko_attrs1, "4", component);

        Locale_tag({
            text: "Course"
          }, out, __component, "5");

        out.ee();

        out.e("h4", marko_attrs2, "6", component, 1)
          .t(input.name, component);

        out.e("div", marko_attrs3, "7", component, 1)
          .e("p", marko_attrs5, "8", component, 1)
            .t(input.description, component);

        Schedules_tag({
            list: input.dates
          }, out, __component, "9");

        if (input.status == "new") {
          out.n(marko_node2, component);

          out.be("button", marko_attrs6, "11", component, null, 0, {
              onclick: __component.d("click", () => component.emit('start'), false)
            });

          Locale_tag({
              text: "Get started"
            }, out, __component, "12");

          Preloader_tag({
              active: input.staging,
              class: "font-medium-5"
            }, out, __component, "13");

          out.ee();
        }

        out.n(marko_node0, component);

        out.n(marko_node1, component);

        Row_tag({
            col: [
                {
                    renderBody: function(out) {
                      if (!isEmpty(input.about)) {
                        out.be("h5", null, "18", component);

                        Locale_tag({
                            text: "About",
                            class: "font-medium-2"
                          }, out, __component, "19");

                        out.ee();

                        QuillEditor_tag({
                            value: input.about,
                            readOnly: true,
                            height: "auto"
                          }, out, __component, "20");
                      }

                      if (!isEmpty(input.objectives)) {
                        out.be("h5", null, "21", component);

                        Locale_tag({
                            text: "Objectives",
                            class: "font-medium-2"
                          }, out, __component, "22");

                        out.ee();

                        QuillEditor_tag({
                            value: input.objectives,
                            readOnly: true,
                            height: "auto"
                          }, out, __component, "23");
                      }

                      if (!isEmpty(input.policy)) {
                        out.be("h5", null, "24", component);

                        Locale_tag({
                            text: "Policy",
                            class: "font-medium-2"
                          }, out, __component, "25");

                        out.ee();

                        QuillEditor_tag({
                            value: input.policy,
                            readOnly: true,
                            height: "auto"
                          }, out, __component, "26");
                      }

                      if (!isEmpty(input.readings)) {
                        out.be("h5", null, "27", component);

                        Locale_tag({
                            text: "Readings",
                            class: "font-medium-2"
                          }, out, __component, "28");

                        out.ee();

                        QuillEditor_tag({
                            value: input.readings,
                            readOnly: true,
                            height: "auto"
                          }, out, __component, "29");
                      }
                    }
                  },
                {
                    class: "col-md-5 col-12",
                    renderBody: function(out) {
                      out.be("div", marko_attrs7, "31", component);

                      out.be("div", marko_attrs8, "32", component);

                      out.be("ul", marko_attrs9, "33", component);

                      if (input.price && input.price.amount) {
                        out.be("li", marko_attrs13, "34", component);

                        Row_tag({
                            class: "no-gutters",
                            col: [
                                {
                                    class: "col-5 d-flex align-items-center",
                                    renderBody: function(out) {
                                      out.n(marko_node4, component);

                                      out.t(" ");

                                      Locale_tag({
                                          text: "Price"
                                        }, out, __component, "38");
                                    }
                                  },
                                {
                                    renderBody: function(out) {
                                      Price_tag({
                                          amount: input.price.amount,
                                          currency: input.price.currency
                                        }, out, __component, "40");
                                    }
                                  }
                              ]
                          }, out, __component, "35");

                        out.ee();
                      }

                      if (Array.isArray(input.packages) && input.packages.length) {
                        out.be("li", marko_attrs14, "41", component);

                        Row_tag({
                            class: "no-gutters",
                            col: [
                                {
                                    class: "col-5 d-flex align-items-center",
                                    renderBody: function(out) {
                                      out.n(marko_node5, component);

                                      out.t(" ");

                                      Locale_tag({
                                          text: "Packages"
                                        }, out, __component, "45");
                                    }
                                  },
                                {
                                    renderBody: function(out) {
                                      out.be("ul", marko_attrs15, "47", component);

                                      marko_forOf(input.packages, function(each, index) {
                                        var $keyValue$0 = "@" + index,
                                            $keyScope$0 = "[" + ($keyValue$0 + "]");

                                        out.e("li", marko_attrs16, $keyValue$0, component, 1)
                                          .e("div", marko_attrs17, "48" + $keyScope$0, component, 1)
                                            .e("div", marko_attrs18, "49" + $keyScope$0, component, 1)
                                              .e("span", marko_attrs19, "50" + $keyScope$0, component, 1)
                                                .t(each.toCapitalCase(), component);
                                      });

                                      out.ee();
                                    }
                                  }
                              ]
                          }, out, __component, "42");

                        out.ee();
                      }

                      out.be("li", marko_attrs10, "51", component);

                      Row_tag({
                          class: "no-gutters",
                          col: [
                              {
                                  class: "col-5 d-flex align-items-center",
                                  renderBody: function(out) {
                                    out.n(marko_node6, component);

                                    out.t(" ");

                                    Locale_tag({
                                        text: "Subject"
                                      }, out, __component, "55");
                                  }
                                },
                              {
                                  renderBody: function(out) {
                                    out.e("span", null, "57", component, 1)
                                      .t(input.categories && input.categories[0] ? input.categories[0].name : "Unknown", component);
                                  }
                                }
                            ]
                        }, out, __component, "52");

                      out.ee();

                      out.be("li", marko_attrs11, "58", component);

                      Row_tag({
                          class: "no-gutters",
                          col: [
                              {
                                  class: "col-5 d-flex align-items-center",
                                  renderBody: function(out) {
                                    out.n(marko_node7, component);

                                    out.t(" ");

                                    Locale_tag({
                                        text: "Level"
                                      }, out, __component, "62");
                                  }
                                },
                              {
                                  renderBody: function(out) {
                                    DifficultyLevel_tag({
                                        type: input.difficultyLevel,
                                        onlyvalue: true
                                      }, out, __component, "64");
                                  }
                                }
                            ]
                        }, out, __component, "59");

                      out.ee();

                      out.be("li", marko_attrs12, "65", component);

                      Row_tag({
                          class: "no-gutters",
                          col: [
                              {
                                  class: "col-5 d-flex align-items-center",
                                  renderBody: function(out) {
                                    out.n(marko_node8, component);

                                    out.t(" ");

                                    Locale_tag({
                                        text: "Multi-Language"
                                      }, out, __component, "69");
                                  }
                                },
                              {
                                  renderBody: function(out) {
                                    out.e("span", null, "71", component, 1)
                                      .t(input.multiLanguage ? "Yes" : "No", component);
                                  }
                                }
                            ]
                        }, out, __component, "66");

                      out.ee();

                      out.ee();

                      out.ee();

                      out.ee();

                      if (Array.isArray(input.prerequisites) && input.prerequisites.length) {
                        Card_tag({
                            body: {
                                renderBody: function(out) {
                                  out.be("h6", marko_attrs20, "74", component);

                                  Locale_tag({
                                      text: "Prerequisites"
                                    }, out, __component, "75");

                                  out.ee();

                                  out.n(marko_node9, component);

                                  out.be("div", marko_attrs21, "77", component);

                                  var $for$0 = 0;

                                  marko_forOf(input.prerequisites, function({ label, link }) {
                                    var $keyScope$1 = "[" + (($for$0++) + "]");

                                    if (link) {
                                      out.be("a", {
                                          type: "button",
                                          "class": "btn btn-outline-secondary d-inline-block mr-2 mb-2",
                                          href: link,
                                          target: "_blank"
                                        }, "78" + $keyScope$1, component);

                                      Locale_tag({
                                          text: label
                                        }, out, __component, "79" + $keyScope$1);

                                      out.ee();
                                    } else {
                                      Locale_tag({
                                          text: label,
                                          class: "btn btn-outline-secondary mr-2 mb-2"
                                        }, out, __component, "80" + $keyScope$1);
                                    }
                                  });

                                  out.ee();
                                }
                              }
                          }, out, __component, "72");
                      }

                      out.n(marko_node3, component);

                      if (input.status == "new") {
                        out.be("button", marko_attrs22, "82", component, null, 0, {
                            onclick: __component.d("click", () => component.emit('start'), false)
                          });

                        Locale_tag({
                            text: "Start Now"
                          }, out, __component, "83");

                        Preloader_tag({
                            active: input.staging,
                            class: "font-medium-5"
                          }, out, __component, "84");

                        out.ee();
                      }
                    }
                  }
              ]
          }, out, __component, "16");

        out.ee();
      }
    }, out, __component, "0");
}

marko_template._ = marko_renderer(render, {
    d_: true,
    e_: marko_componentType
  });

marko_template.Component = marko_defineComponent({}, marko_template._);
